export const SET_WORKSPACE_SETTINGS = 'SET_WORKSPACE_SETTINGS';
export const SET_ACTIVE_WORKSPACE = 'SET_ACTIVE_WORKSPACE';
export const SET_ACTIVE_WORKSPACE_BANK_ACCOUNT = 'SET_ACTIVE_WORKSPACE_BANK_ACCOUNT';
export const SET_WORKSPACE_SIGNATURE_FOOTER_SETTINGS = 'SET_WORKSPACE_SIGNATURE_FOOTER_SETTINGS';
export const SET_WORKSPACE_BANK_ACCOUNTS = 'SET_WORKSPACE_BANK_ACCOUNTS';
export const SET_MEMBERS_JOB_POSITIONS = 'SET_MEMBERS_JOB_POSITIONS';
